import React from 'react';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import './AssistButton.css';

/**
 * Opens the assist strip.
 *
 * Takes the give-up button's slot rather than adding one: the controls row was
 * already six items wide on mobile. Give-up now sits inside the strip as the
 * bottom rung of the same ladder, which is also where it belongs — it was
 * previously the only help on offer, and it ended the puzzle.
 */
const AssistButton = ({ onClick, isComplete }) => (
  <button
    type="button"
    className="assist-button"
    onClick={onClick}
    disabled={isComplete}
    aria-label="Get help"
    title="Get help"
  >
    <LightbulbOutlinedIcon sx={{ fontSize: 20 }} />
  </button>
);

export default AssistButton;
